import { Button } from "react-bootstrap";
import { VscCheckAll } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import IconText from "./IconText";

const CheckedButton = ({ url = null, onClick = null }) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="success"
      size="sm"
      onClick={() => (onClick ? onClick() : navigate(url))}
    >
      <IconText icon={<VscCheckAll />} />
    </Button>
  );
};

export default CheckedButton;
